var y = function(a, c) {
  return y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, r) {
    e.__proto__ = r;
  } || function(e, r) {
    for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
  }, y(a, c);
};
function h(a, c) {
  if (typeof c != "function" && c !== null)
    throw new TypeError("Class extends value " + String(c) + " is not a constructor or null");
  y(a, c);
  function e() {
    this.constructor = a;
  }
  a.prototype = c === null ? Object.create(c) : (e.prototype = c.prototype, new e());
}
var p = function() {
  return p = Object.assign || function(c) {
    for (var e, r = 1, o = arguments.length; r < o; r++) {
      e = arguments[r];
      for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && (c[t] = e[t]);
    }
    return c;
  }, p.apply(this, arguments);
};
function _(a, c) {
  var e = {};
  for (var r in a) Object.prototype.hasOwnProperty.call(a, r) && c.indexOf(r) < 0 && (e[r] = a[r]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(a); o < r.length; o++)
      c.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(a, r[o]) && (e[r[o]] = a[r[o]]);
  return e;
}
function b(a, c, e, r) {
  function o(t) {
    return t instanceof e ? t : new e(function(u) {
      u(t);
    });
  }
  return new (e || (e = Promise))(function(t, u) {
    function i(l) {
      try {
        n(r.next(l));
      } catch (s) {
        u(s);
      }
    }
    function f(l) {
      try {
        n(r.throw(l));
      } catch (s) {
        u(s);
      }
    }
    function n(l) {
      l.done ? t(l.value) : o(l.value).then(i, f);
    }
    n((r = r.apply(a, c || [])).next());
  });
}
function w(a, c) {
  var e = { label: 0, sent: function() {
    if (t[0] & 1) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, r, o, t, u = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return u.next = i(0), u.throw = i(1), u.return = i(2), typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function i(n) {
    return function(l) {
      return f([n, l]);
    };
  }
  function f(n) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; u && (u = 0, n[0] && (e = 0)), e; ) try {
      if (r = 1, o && (t = n[0] & 2 ? o.return : n[0] ? o.throw || ((t = o.return) && t.call(o), 0) : o.next) && !(t = t.call(o, n[1])).done) return t;
      switch (o = 0, t && (n = [n[0] & 2, t.value]), n[0]) {
        case 0:
        case 1:
          t = n;
          break;
        case 4:
          return e.label++, { value: n[1], done: !1 };
        case 5:
          e.label++, o = n[1], n = [0];
          continue;
        case 7:
          n = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (t = e.trys, !(t = t.length > 0 && t[t.length - 1]) && (n[0] === 6 || n[0] === 2)) {
            e = 0;
            continue;
          }
          if (n[0] === 3 && (!t || n[1] > t[0] && n[1] < t[3])) {
            e.label = n[1];
            break;
          }
          if (n[0] === 6 && e.label < t[1]) {
            e.label = t[1], t = n;
            break;
          }
          if (t && e.label < t[2]) {
            e.label = t[2], e.ops.push(n);
            break;
          }
          t[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      n = c.call(a, e);
    } catch (l) {
      n = [6, l], o = 0;
    } finally {
      r = t = 0;
    }
    if (n[0] & 5) throw n[1];
    return { value: n[0] ? n[1] : void 0, done: !0 };
  }
}
function O(a, c, e) {
  if (e || arguments.length === 2) for (var r = 0, o = c.length, t; r < o; r++)
    (t || !(r in c)) && (t || (t = Array.prototype.slice.call(c, 0, r)), t[r] = c[r]);
  return a.concat(t || Array.prototype.slice.call(c));
}
export {
  p as __assign,
  b as __awaiter,
  h as __extends,
  w as __generator,
  _ as __rest,
  O as __spreadArray
};
//# sourceMappingURL=index11.js.map
